import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { formatApiError } from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { exchangeEmergentSession } = useAuth();
  const processed = useRef(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [redirectTo, setRedirectTo] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sid = match?.[1];
    if (!sid) {
      navigate("/login", { replace: true });
      return;
    }
    let intendedRole = null;
    try {
      intendedRole = sessionStorage.getItem("venturaz_google_role");
      sessionStorage.removeItem("venturaz_google_role");
    } catch { /* ignore */ }
    (async () => {
      try {
        const user = await exchangeEmergentSession(sid, intendedRole);
        window.history.replaceState(null, "", window.location.pathname);
        const role = user?.role;
        if (role === "investor") navigate("/investor/dashboard", { replace: true });
        else if (role && role !== "startup") navigate("/admin/dashboard", { replace: true });
        else navigate("/startup/dashboard", { replace: true });
      } catch (err) {
        const status = err?.response?.status;
        if (status === 403) {
          const detail = formatApiError(err);
          setErrorMsg(detail);
          setRedirectTo("/admin/login");
          setTimeout(() => navigate("/admin/login", { replace: true, state: { blockedGoogle: true, message: detail } }), 4000);
        } else {
          navigate("/login", { replace: true });
        }
      }
    })();
  }, [exchangeEmergentSession, navigate]);

  if (errorMsg) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-transparent px-6">
        <div className="max-w-md w-full border border-gold/40 bg-gold/[0.04] p-8 text-center" data-testid="auth-callback-blocked">
          <div className="overline mb-3 text-gold">Team Account Detected</div>
          <div className="font-heading text-ink text-xl mb-4">{errorMsg}</div>
          <div className="text-sm text-ink-muted">
            Redirecting to <span className="text-gold font-mono">{redirectTo}</span> in a few seconds…
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-transparent">
      <div className="text-center">
        <div className="overline mb-3">VenturaZ</div>
        <div className="text-ink-soft font-heading">Finalising your session…</div>
      </div>
    </div>
  );
}
